import JustValidate from "just-validate";
import {trackEvent} from "../utils/plausible";
import {dictionary, lang} from "../utils/validator.language";
import {passwordStrength} from "check-password-strength";

export function validateLoginForm() {
    Alpine.data('login_form', () => ({
        form: null,
        validator: null,
        has_error: false,

        init() {
            this.form = this.$refs.user_login;
            this.validator = new JustValidate(this.form, {
                errorLabelStyle: {
                    color: 'var(--wp--preset--color--alerts-error-900)'
                },
                validateBeforeSubmitting: true
            }, dictionary);
        },

        validate(e) {
            this.has_error = false;

            this.validator
                .addField("#user_login_email", [{
                    rule: 'required',
                },
                    {
                        rule: 'email'
                    }])
                .addField('#user_login_password', [
                    {
                        rule: 'required',
                    }
                ])
                .setCurrentLocale(lang)

            this.validator
                .revalidate().then(isValid => {
                if (isValid) {
                    console.log(this.form)
                    let formData = new FormData(this.form)
                    formData.append('action', 'mh_user_login');

                    fetch(site_objects.ajax_url, {
                        method: "POST",
                        body: formData
                    })
                        .then((res) => res.json())
                        .then((res) => {
                            if (!res.success) {
                                this.form.querySelector('.error-text').innerHTML = res.data.error
                                this.has_error = true;

                            } else {
                                trackEvent('Login Successful')

                                window.location.href = res.data.redirect_to
                            }

                        })
                }
            })

        }
    }));
}

export function validateCreateForm() {
    Alpine.data('create_user_form', () => ({
        form: null,
        validator: null,
        has_error: false,
        is_created: false,

        init() {
            this.form = this.$refs.user_create;
            this.validator = new JustValidate(this.form, {
                errorLabelStyle: {
                    color: 'var(--wp--preset--color--alerts-error-900)'
                },
                validateBeforeSubmitting: true
            }, dictionary);
        },

        validate(e) {
            this.has_error = false;

            this.validator
                .addField("#user_create_email", [{
                    rule: 'required',
                },
                    {
                        rule: 'email'
                    }])
                .addField('#user_create_conditions', [
                    {
                        rule: 'required',
                        errorMessage: 'user_create_conditions'
                    }
                ])
                .setCurrentLocale(lang)

            this.validator
                .revalidate().then(isValid => {
                if (isValid) {
                    let formData = new FormData(this.form)
                    formData.append('action', 'mh_user_create');

                    fetch(site_objects.ajax_url, {
                        method: "POST",
                        body: formData
                    })
                        .then((res) => res.json())
                        .then((res) => {

                            if (!res.success) {
                                this.form.querySelector('.error-text').innerHTML = res.data.error
                                this.has_error = true;

                            } else {
                                trackEvent('User Created')
                                this.form.querySelector('.create_form_fields').classList.add('hidden')
                                this.form.querySelector('.user_create_btn_area').classList.add('hidden')
                                this.form.querySelector('.success-text').innerHTML = res.data.success
                                this.is_created = true;
                            }
                        })
                }
            })

        }
    }));
}

export function validatePasswordForm() {
    Alpine.data('password_form', () => ({
        form: null,
        validator: null,
        has_error: false,
        is_success: false,
        password_length: 0,
        password_contains_type: [],


        init() {
            this.form = this.$refs.password_form;
            this.validator = new JustValidate(this.form, {
                validateBeforeSubmitting: true,
                errorLabelStyle: {
                    color: 'var(--wp--preset--color--alerts-error-900)'
                },
            }, dictionary);
        },

        password_strength_meter()  {
            this.password_length = this.$el.value.length;
            this.password_contains_type = passwordStrength(this.$el.value).contains
        },

        password_contains(types){
            return [...arguments].every(element => this.password_contains_type.includes(element))
        },

        validate(e) {
            this.has_error = false;

            this.validator
                .addField("#new_password", [
                    {
                        rule: 'required',
                    },
                    {
                        validator: (value) => {

                            return passwordStrength(value).id >= 3;
                        },

                        errorMessage : ' '
                    }

                ])
                .addField("#repeat_new_password", [
                    {
                        rule: 'required',
                    },
                    {
                        validator: (value, fields) => {
                            if (fields['#new_password'] && fields['#new_password'].elem) {
                                const repeatPasswordValue = fields['#new_password'].elem.value;
                                return value === repeatPasswordValue;
                            }

                            return true;
                        },
                        errorMessage: 'Passwords should be the same',
                    },
                ])
                .setCurrentLocale(lang)

            this.validator
                .revalidate().then(isValid => {
                if (isValid) {
                    let formData = new FormData(this.form)
                    formData.append('action', 'mh_set_new_password');

                    fetch(site_objects.ajax_url, {
                        method: "POST",
                        body: formData
                    })
                        .then((res) => res.json())
                        .then((res) => {
                            if (!res.success) {
                                this.form.querySelector('.error-text').innerHTML = res.data
                                this.has_error = true;
                                this.validator.refresh();

                            } else {
                                this.form.querySelector('.success-text').innerHTML = res.data
                                this.is_success = true;
                                this.validator.refresh();
                                this.form.reset()
                            }
                        })
                }
            })

        }

    }));
}

export function validateNotificationForm() {
    Alpine.data('notification_form', (user_phone_number = null) => ({
        form: null,
        validator: null,
        has_error: false,
        is_success: false,

        phone_number: null,

        init() {
            this.form = this.$refs.notification_form;
            this.validator = new JustValidate(this.form, {
                errorLabelStyle: {
                    color: 'var(--wp--preset--color--alerts-error-900)'
                },
                validateBeforeSubmitting: false,
            }, dictionary);

            this.phone_number = user_phone_number;
        },

        is_editable: {
            ["x-text"]() {
                return (user_phone_number == null) ? AlpineI18n.t('notification_btn_subscribe') : AlpineI18n.t('notification_btn_edit')
            },
        },

        validate(e) {
            this.has_error = false;
            this.is_success = false;

            if (user_phone_number === null) {

                this.validator
                    .addField("#phone_number", [
                        {
                            rule: 'required',
                        },
                        {
                            rule: 'number',
                        },
                    ])
                    .addField("#notification_conditions", [
                        {
                            rule: 'required',
                            errorMessage: 'notification_conditions',
                        },
                    ])

                    .setCurrentLocale(lang)
            } else {
                this.validator
                    .addField("#phone_number", [
                        {
                            rule: 'required',
                        },
                        {
                            rule: 'number',
                        },
                    ])

                    .setCurrentLocale(lang)
            }


            this.validator
                .revalidate().then(isValid => {
                if (isValid) {
                    let formData = new FormData(this.form)
                    formData.append('action', 'mh_set_notifications');

                    fetch(site_objects.ajax_url, {
                        method: "POST",
                        body: formData
                    })
                        .then((res) => res.json())
                        .then((res) => {
                            if (!res.success) {
                                this.form.querySelector('.error-text').innerHTML = res.data
                                this.has_error = true;
                                this.validator.refresh();

                            } else {
                                this.form.querySelector('.success-text').innerHTML = res.data
                                this.$store.userNotificationData.is_subscribed = true;

                                this.is_success = true;
                                this.validator.refresh();
                            }
                        })
                }
            })

        },

        unsubscribe() {
            let formData = new FormData(this.form)
            formData.append('action', 'mh_remove_notifications');

            fetch(site_objects.ajax_url, {
                method: "POST",
                body: formData
            })
                .then((res) => res.json())
                .then((res) => {
                    if (!res.success) {
                        this.form.querySelector('.error-text').innerHTML = res.data
                        this.has_error = true;
                        this.validator.refresh();

                    } else {
                        this.$store.userNotificationData.is_subscribed = false;

                        trackEvent('Notification removed')

                        location.reload();
                    }
                })
        },

    }));
}

export function validateDeleteUserForm() {
    Alpine.data('delete_user_form', () => ({
        form: null,
        validator: null,
        has_error: false,

        init() {
            this.form = this.$refs.delete_user_form;
            this.validator = new JustValidate(this.form, {
                errorLabelStyle: {
                    color: 'var(--wp--preset--color--alerts-error-900)'
                },
                validateBeforeSubmitting: false,
            }, dictionary);
        },

        validate(e) {
            this.has_error = false;

            this.validator
                .addField('#password', [{
                    rule: 'required',
                }])
                .setCurrentLocale(lang)

            this.validator
                .revalidate().then(isValid => {
                if (isValid) {
                    let formData = new FormData(this.form)
                    formData.append('action', 'mh_delete_user')


                    fetch(site_objects.ajax_url, {
                        method: "POST",
                        body: formData
                    })
                        .then((res) => res.json())
                        .then((res) => {
                            if (!res.success) {
                                this.form.querySelector('.error-text').innerHTML = res.data
                                this.has_error = true;
                                this.validator.refresh();
                            } else {

                                trackEvent('User Deleted')
                                window.location.href = res.data.redirect_to
                            }
                        })
                }
            })
        }

    }))
}